import { getPageSource, track } from '@mc/track-event'

export const trackCertificatesRowViewed = (rowPositionIndex: number) =>
  track('Plans Page Row Viewed', {
    category: 'pricing matrix',
    row: 'certificates',
    row_name: 'certificates',
    row_position_index: rowPositionIndex,
    page_source: getPageSource(),
  })
